import { html } from 'onefold';
import { CodeBlock } from '../../components/CodeBlock';
import { Callout } from '../../components/Callout';

export function InstallPage(): Node {
  return html`
    <div>
      <h1>Installation</h1>
      <p>Get onefold into your project.</p>

      <h2>Scaffold a New Project (Recommended)</h2>
      <p>The fastest way to start is with the official CLI:</p>
      ${CodeBlock(`npm create onefold@latest my-app
cd my-app
npm install
npm run dev`)}

      <p>This creates a fully configured project with TypeScript, a dev server, and a production build script.</p>

      <h2>Add to an Existing Project</h2>
      ${CodeBlock(`# npm
npm install onefold

# pnpm
pnpm add onefold

# yarn
yarn add onefold`)}

      <h2>CDN / No Bundler</h2>
      <p>Import directly from a CDN for prototyping:</p>
      ${CodeBlock(`<script type="module">
  import { createSignal, html, mount } from 'https://esm.sh/onefold@latest';

  const count = createSignal(0);
  mount(
    html\`<button onclick=\${() => count.set(n => n + 1)}>
      Clicked \${() => count()} times
    </button>\`,
    document.getElementById('app')
  );
</script>`)}

      ${Callout('onefold ships as standard ES modules. No special bundler plugins or Babel transforms are needed.')}

      <h2>TypeScript Configuration</h2>
      <p>For the best experience, use strict mode in your <code>tsconfig.json</code>:</p>
      ${CodeBlock(`{
  "compilerOptions": {
    "target": "ES2022",
    "module": "ESNext",
    "moduleResolution": "bundler",
    "strict": true,
    "noUncheckedIndexedAccess": true,
    "lib": ["ES2022", "DOM", "DOM.Iterable"]
  }
}`)}

      <h2>Requirements</h2>
      <ul>
        <li>Node.js 18+</li>
        <li>Any modern bundler (esbuild, Vite, Rollup, webpack) — or none at all</li>
        <li>Modern browser (Chrome 89+, Firefox 108+, Safari 16.4+, Edge 89+)</li>
      </ul>
    </div>
  `;
}
